<template>
    <div style="height: 180px;overflow: hidden">
        <div style="color: #ffffff" :class="{ animate: animate }">
            <div v-for="item, index of cardRecords" :key="index" class="around-center">
                <img style="margin: 5px 0;width: 50px;height: 50px" src="../../../../assets/image/homeTemp/overcast.png" />
                <div>{{ item.name }}</div>
                <div>{{ item.job }}</div>
                <div>进闸时间：{{ getDateAndTimeStr() }}</div>
            </div>
        </div>
    </div>
</template>

<script>
// import myHttp from '../../../../api/project/index';
// import base from '../../../../untils/base'
import { getDateAndTimeStr } from '../../../../untils/misc.js';

export default {
    name: 'personEnterAndExit',

    data() {
        return {
            // httpCtx: base.httpCtx,
            projectId: '',
            cardRecords: [
                { name: 'zbb', job: '昂森钢筋工' },
                { name: 'zbb', job: '昂森钢筋工' },
                { name: 'zbb', job: '昂森钢筋工' },
                { name: 'zbb', job: '昂森钢筋工' },
                { name: 'zbb', job: '昂森钢筋工' },
            ],
            timer: undefined,
            animate: false,
        }
    },

    created() {
        // this.projectId = util.session.get('groupId')
        this.getCardRecords();
    },


    methods: {
        getDateAndTimeStr() {
            return getDateAndTimeStr(new Date());
        },

        getCardRecords() {
            // myHttp.punchingCardRecord({
            //     projectId: this.projectId
            // }).then(res => {
            //     //console.log(res);
            //     if (res.data.code === 200) {
            //     this.cardRecords = res.data.data || []
                this.timer = setInterval(this.scroll, 2000)
            //     }
            // })
        },

        scroll() {
            if (this.cardRecords.length > 3) {
                this.animate = true;
                this.cardRecords.push(this.cardRecords[0]);
                this.cardRecords.shift();
                setTimeout(() => {
                    this.animate = false;
                }, 1200)
            } else {
                window.clearInterval(this.timer)
            }
        },
    }
}
</script>

<style lang="less" scoped>
.animate {
  margin-top: -60px;
  transition: all 1s;
}

</style>
